export { default } from '@components/IntersectionObserver/IntersectionObserver'
